import React from 'react';

import filterBB from 'assets/images/performanceRefresh/filterProductStats/filter-BB.png';
import filterBS from 'assets/images/performanceRefresh/filterProductStats/filter-BS.png';
import filterCC from 'assets/images/performanceRefresh/filterProductStats/filter-CC.png';
import filterRP from 'assets/images/performanceRefresh/filterProductStats/filter-RP.png';
import filterHW from 'assets/images/performanceRefresh/filterProductStats/filter-HW.png';
import filterMB from 'assets/images/performanceRefresh/filterProductStats/filter-MB.png';
import filterOR from 'assets/images/performanceRefresh/filterProductStats/filter-OR.png';

const productStats = {
  air: [
    {
      label: 'CADR',
      stats: {
        BB: {
          value: '460',
          isBold: true,
        },
        BS: {
          value: '412',
          isBold: true,
        },
        CC: {
          value: '350',
          isBold: false,
        },
        RP: {
          value: '386',
          isBold: true,
        },
        HW: {
          value: '308',
          isBold: false,
        },
        MB: {
          value: '262',
          isBold: false,
        },
        OR: {
          value: '265',
          isBold: false,
        },
      },
    },
    {
      label: 'TVOC REMOVAL rate',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '74.85%',
          isBold: false,
        },
        CC: {
          value: '75.56%',
          isBold: false,
        },
        HW: {
          value: '92.81%',
          isBold: true,
        },
        MB: {
          value: '92.48%',
          isBold: true,
        },
        OR: {
          value: '97.89%',
          isBold: true,
        },
      },
    },
    {
      label: 'FORMALDEHYDE',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '45.4%',
          isBold: false,
        },
        CC: {
          value: '34.00%',
          isBold: false,
        },
        HW: {
          value: '95.60%',
          isBold: true,
        },
        MB: {
          value: '48.80%',
          isBold: false,
        },
        OR: {
          value: '96.60%',
          isBold: true,
        },
      },
    },
    {
      label: 'AMMONIA',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '21.52%',
          isBold: false,
        },
        CC: {
          value: '75.60%',
          isBold: true,
        },
        HW: {
          value: '31.20%',
          isBold: false,
        },
        MB: {
          value: '4.80%',
          isBold: false,
        },
        OR: {
          value: '17.20%',
          isBold: false,
        },
      },
    },
    {
      label: 'BENZENE',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '78.57%',
          isBold: false,
        },
        CC: {
          value: '75.00%',
          isBold: false,
        },
        HW: {
          value: '91.02%',
          isBold: true,
        },
        MB: {
          value: '92.98%',
          isBold: true,
        },
        OR: {
          value: '96.94%',
          isBold: true,
        },
      },
    },
    {
      label: 'TOLUENE',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '76.39%',
          isBold: false,
        },
        CC: {
          value: '77.33%',
          isBold: false,
        },
        HW: {
          value: '94.86%',
          isBold: true,
        },
        MB: {
          value: '94.80%',
          isBold: true,
        },
        OR: {
          value: '98.99%',
          isBold: true,
        },
      },
    },
    {
      label: 'BUTYL ACETATE',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '75.58%',
          isBold: false,
        },
        CC: {
          value: '76.40%',
          isBold: false,
        },
        HW: {
          value: '93.79%',
          isBold: true,
        },
        MB: {
          value: '93.33%',
          isBold: true,
        },
        OR: {
          value: '98.49%',
          isBold: true,
        },
      },
    },
    {
      label: 'N-UNDECANE',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '75.34%',
          isBold: false,
        },
        CC: {
          value: '76.92%',
          isBold: false,
        },
        HW: {
          value: '93.33%',
          isBold: true,
        },
        MB: {
          value: '92.47%',
          isBold: true,
        },
        OR: {
          value: '98.06%',
          isBold: true,
        },
      },
    },
    {
      label: 'ETHYLBENZENE',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '74.68%',
          isBold: false,
        },
        CC: {
          value: '75.61%',
          isBold: false,
        },
        HW: {
          value: '92.96%',
          isBold: true,
        },
        MB: {
          value: '92.20%',
          isBold: true,
        },
        OR: {
          value: '98.00%',
          isBold: true,
        },
      },
    },
    {
      label: 'P-XYLENEOU',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '73.97%',
          isBold: false,
        },
        CC: {
          value: '76.00%',
          isBold: false,
        },
        HW: {
          value: '93.47%',
          isBold: true,
        },
        MB: {
          value: '92.75%',
          isBold: true,
        },
        OR: {
          value: '98.24%',
          isBold: true,
        },
      },
    },
    {
      label: 'M-XYLENE',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '74.68%',
          isBold: false,
        },
        CC: {
          value: '75.31%',
          isBold: false,
        },
        HW: {
          value: '93.25%',
          isBold: true,
        },
        MB: {
          value: '92.56%',
          isBold: true,
        },
        OR: {
          value: '98.13%',
          isBold: true,
        },
      },
    },
    {
      label: 'O-XYLENE',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '74.30%',
          isBold: false,
        },
        CC: {
          value: '73.61%',
          isBold: false,
        },
        HW: {
          value: '92.60%',
          isBold: true,
        },
        MB: {
          value: '91.95%',
          isBold: true,
        },
        OR: {
          value: '97.89%',
          isBold: true,
        },
      },
    },
    {
      label: 'STYRENE',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '70.00%',
          isBold: false,
        },
        CC: {
          value: '71.43%',
          isBold: false,
        },
        HW: {
          value: '88.52%',
          isBold: true,
        },
        MB: {
          value: '89.03%',
          isBold: true,
        },
        OR: {
          value: '96.10%',
          isBold: true,
        },
      },
    },
  ],
  airMini: [
    {
      label: 'CADR',
      stats: {
        BB: {
          value: '357',
          isBold: true,
        },
        BS: {
          value: '330',
          isBold: true,
        },
        CC: {
          value: '290',
          isBold: false,
        },
        OR: {
          value: '231',
          isBold: false,
        },
      },
    },
    {
      label: 'TVOC REMOVAL rate',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        CC: {
          value: '69.9%',
          isBold: false,
        },
        OR: {
          value: '93.0%',
          isBold: false,
        },
      },
    },
    {
      label: 'FORMALDEHYDE',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        CC: {
          value: 'N/A',
          isBold: false,
        },
        OR: {
          value: '95.0%',
          isBold: true,
        },
      },
    },
    {
      label: 'AMMONIA',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        CC: {
          value: '79.0%',
          isBold: true,
        },
        OR: {
          value: 'N/A',
          isBold: false,
        },
      },
    },
  ],
};

const productStatsResponsive = {
  image: {
    BB: filterBB,
    BS: filterBS,
    CC: filterCC,
    RP: filterRP,
    HW: filterHW,
    MB: filterMB,
    OR: filterOR,
  },

  description: {
    BB: 'For the everyday lover of clean air',
    BS: 'Helping you fight back against allergens',
    CC: 'Making the air clean and safe for your littles',
    RP: 'Clearing the air for fur families',
    HW: 'Protection from ALL the things',
    MB: 'Protection from ALL the things',
    OR: 'Extra protection when you’re breathing for two',
  },

  air: [
    {
      label: <>CADR</>,
      type: '(m³/hr)',
      stats: {
        BB: {
          value: '460',
          isBold: true,
        },
        BS: {
          value: '412',
          isBold: true,
        },
        CC: {
          value: '350',
          isBold: false,
        },
        RP: {
          value: '386',
          isBold: true,
        },
        HW: {
          value: '308',
          isBold: false,
        },
        MB: {
          value: '262',
          isBold: false,
        },
        OR: {
          value: '265',
          isBold: false,
        },
      },
    },
    {
      label: <>TVOC</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '74.85%',
          isBold: false,
        },
        CC: {
          value: '75.56%',
          isBold: false,
        },
        HW: {
          value: '92.81%',
          isBold: true,
        },
        MB: {
          value: '92.48%',
          isBold: true,
        },
        OR: {
          value: '97.89%',
          isBold: true,
        },
      },
    },
    {
      label: <>CH₂O</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '45.4%',
          isBold: false,
        },
        CC: {
          value: '34.00%',
          isBold: false,
        },
        HW: {
          value: '95.60%',
          isBold: true,
        },
        MB: {
          value: '48.80%',
          isBold: false,
        },
        OR: {
          value: '96.60%',
          isBold: true,
        },
      },
    },
    {
      label: <>AMMONIA</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '21.52%',
          isBold: false,
        },
        CC: {
          value: '75.60%',
          isBold: true,
        },
        HW: {
          value: '31.20%',
          isBold: false,
        },
        MB: {
          value: '4.80%',
          isBold: false,
        },
        OR: {
          value: '17.20%',
          isBold: false,
        },
      },
    },
    {
      label: <>BENZENE</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '78.57%',
          isBold: false,
        },
        CC: {
          value: '75.00%',
          isBold: false,
        },
        HW: {
          value: '91.02%',
          isBold: true,
        },
        MB: {
          value: '92.98%',
          isBold: true,
        },
        OR: {
          value: '96.94%',
          isBold: true,
        },
      },
    },
    {
      label: <>TOLUENE</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '76.39%',
          isBold: false,
        },
        CC: {
          value: '77.33%',
          isBold: false,
        },
        HW: {
          value: '94.86%',
          isBold: true,
        },
        MB: {
          value: '94.80%',
          isBold: true,
        },
        OR: {
          value: '98.99%',
          isBold: true,
        },
      },
    },
    {
      label: <>BUTYL ACETATE</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '75.58%',
          isBold: false,
        },
        CC: {
          value: '76.40%',
          isBold: false,
        },
        HW: {
          value: '93.79%',
          isBold: true,
        },
        MB: {
          value: '93.33%',
          isBold: true,
        },
        OR: {
          value: '98.49%',
          isBold: true,
        },
      },
    },
    {
      label: <>N-UNDECANE</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '75.34%',
          isBold: false,
        },
        CC: {
          value: '76.92%',
          isBold: false,
        },
        HW: {
          value: '93.33%',
          isBold: true,
        },
        MB: {
          value: '92.47%',
          isBold: true,
        },
        OR: {
          value: '98.06%',
          isBold: true,
        },
      },
    },
    {
      label: <>ETHYLBENZENE</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '74.68%',
          isBold: false,
        },
        CC: {
          value: '75.61%',
          isBold: false,
        },
        HW: {
          value: '92.96%',
          isBold: true,
        },
        MB: {
          value: '92.20%',
          isBold: true,
        },
        OR: {
          value: '98.00%',
          isBold: true,
        },
      },
    },
    {
      label: <>P-XYLENEOU</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '73.97%',
          isBold: false,
        },
        CC: {
          value: '76.00%',
          isBold: false,
        },
        HW: {
          value: '93.47%',
          isBold: true,
        },
        MB: {
          value: '92.75%',
          isBold: true,
        },
        OR: {
          value: '98.24%',
          isBold: true,
        },
      },
    },
    {
      label: <>M-XYLENE</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '74.68%',
          isBold: false,
        },
        CC: {
          value: '75.31%',
          isBold: false,
        },
        HW: {
          value: '93.25%',
          isBold: true,
        },
        MB: {
          value: '92.56%',
          isBold: true,
        },
        OR: {
          value: '98.13%',
          isBold: true,
        },
      },
    },
    {
      label: <>O-XYLENE</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '74.30%',
          isBold: false,
        },
        CC: {
          value: '73.61%',
          isBold: false,
        },
        HW: {
          value: '92.60%',
          isBold: true,
        },
        MB: {
          value: '91.95%',
          isBold: true,
        },
        OR: {
          value: '97.89%',
          isBold: true,
        },
      },
    },
    {
      label: <>STYRENE</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        RP: {
          value: '70.00%',
          isBold: false,
        },
        CC: {
          value: '71.43%',
          isBold: false,
        },
        HW: {
          value: '88.52%',
          isBold: true,
        },
        MB: {
          value: '89.03%',
          isBold: true,
        },
        OR: {
          value: '96.10%',
          isBold: true,
        },
      },
    },
  ],
  airMini: [
    {
      label: <>CADR</>,
      type: '(m³/hr)',
      stats: {
        BB: {
          value: '357',
          isBold: true,
        },
        BS: {
          value: '330',
          isBold: true,
        },
        CC: {
          value: '290',
          isBold: false,
        },
        OR: {
          value: '231',
          isBold: false,
        },
      },
    },
    {
      label: <>TVOC</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        CC: {
          value: '69.9%',
          isBold: false,
        },
        OR: {
          value: '93.0%',
          isBold: false,
        },
      },
    },
    {
      label: <>CH₂O</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        CC: {
          value: 'N/A',
          isBold: false,
        },
        OR: {
          value: '95.0%',
          isBold: true,
        },
      },
    },
    {
      label: <>AMMONIA</>,
      type: '% Removal',
      stats: {
        BB: {
          value: 'N/A',
          isBold: false,
        },
        BS: {
          value: 'N/A',
          isBold: false,
        },
        CC: {
          value: '79.0%',
          isBold: true,
        },
        OR: {
          value: 'N/A',
          isBold: false,
        },
      },
    },
  ],
};

export { productStats, productStatsResponsive };
